import React from "react";
import { useSelector } from "react-redux";
import { getActiveGptConversation, getScenarioHelperContextPdfs } from "../state/chatbotSlice";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { MdInfoOutline } from "react-icons/md";

const MAX_CONTEXT = 128000;

interface ContextCounterProps {
  promptText: string;
  chosenLlmProvider: string;
}

const ContextCounter: React.FC<ContextCounterProps> = ({ promptText, chosenLlmProvider }) => {
  const { t } = useTranslation();
  const activeConversation = useSelector(getActiveGptConversation);
  const contextPdfs = useSelector(getScenarioHelperContextPdfs);
  const promptTokens = Math.ceil(promptText.length / 4);
  let currentContextCount = 0;

  if (
    !activeConversation ||
    !activeConversation.input_token_count ||
    activeConversation.input_token_count === 0
  ) {
    currentContextCount = promptTokens;
    if (Array.isArray(contextPdfs)) {
      contextPdfs.forEach((pdf) => {
        const tokenPrediction = pdf?.source_media_cache?.metadata?.tokenPrediction;
        if (Array.isArray(tokenPrediction)) {
          const tokenData = tokenPrediction.find((item: any) => {
            if (chosenLlmProvider === "openai") {
              return item.model === "gpt-4o-mini";
            }
            if (chosenLlmProvider === "mistral") {
              return item.model === "mistral-large-latest";
            }
            return false;
          });
          currentContextCount +=
            tokenData && typeof tokenData.tokenCount === "number" ? tokenData.tokenCount : 0;
        }
      });
    }
  } else {
    currentContextCount = (activeConversation.input_token_count || 0) + promptTokens;
  }

  const isOverLimit = currentContextCount >= MAX_CONTEXT;

  return (
    <div className="flex flex-col items-center justify-center text-sm">
      <div className="flex items-center text-gray-700">
        {t("pages.chat.contextWindow")}
        <Tooltip title={t("pages.chat.contextWindowTooltip")}>
          <span className="ml-1 relative text-[10px] text-gray-500 -top-1">
            <MdInfoOutline size={10} />
          </span>
        </Tooltip>
      </div>
      <div className={`${isOverLimit ? "text-red-500" : "text-gray-700"}`}>
        ≈ {currentContextCount}/{MAX_CONTEXT}
      </div>
      {isOverLimit && (
        <div className="text-xs text-red-500 text-center">
          ⚠️ {t("pages.chat.overContextWindowLimit")}
        </div>
      )}
    </div>
  );
};

export default ContextCounter;
